// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/graphs.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@/assets/img/no-image-car.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/icons/changed_group.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/icons/manual_number_input.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/icons/payment_canceled.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../images/icons/exclamation.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/icons/visit_registration.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/icons/car_returned.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/icons/changed_car_price_categories.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/icons/clock.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/icons/arrow_down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/90-ring-with-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/loadbar.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/nophoto.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/background-share.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/background-share-phone.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/icons/total.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/icons/reviews.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/icons/normative.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/icons/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/icons/emotions/happy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/icons/emotions/nhappy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/icons/emotions/neutral.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/icons/emotions/nsad.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/icons/emotions/sad.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/icons/productivity.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../images/icons/suspicious.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[ng\\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
    display: none !important;
}

body {
    overflow-y: scroll !important;
}

body.modal-open {
    overflow: hidden !important;
}

.modal-auto {
    width: auto;
}

.modal-md {
    width: 75%;
}

.modal-lg {
    width: 42%;
}
@media (max-width: 2000px) {
    .modal-lg {
        width: 60%;
    }
}

@media (max-width: 1200px) {
    .modal-lg {
        width: 83%;
    }
}

.nav .fa-stack {
    margin-top: -0.5em;
    margin-bottom: -0.5em;
}

.text-bold {
    font-weight: bold;
}

.text-italic {
    font-style: italic;
}

.hide, .hidden, .false {
    display: none;
}

.float-left {
    float: left;
}
.float-right {
    float: right;
}
.float-right--inline .suspicious-wrapper {
    display: inline-block;
    vertical-align: top;
    height: 27px;
}
.float-right--inline .visit-icon-image {
    width: 30px;
    height: 27px;
    padding: 5px 6px 6px 5px;
}
.float-right--inline .suspicious-wrapper .visit-icon--transparent {
    display: flex;
    padding: 0;
}
.float-right--inline .suspicious-wrapper .visit-icon-image::before {
    position: relative;
    top: 0;
    left: 0;
    width: 19px;
    transform: none;
}

.float-right--inline .suspicious-wrapper .visit-icon-image--changed-group::before {
    width: 18px;
    top: -1px;
    left: 1px;
}

.float-right--inline .suspicious-wrapper .visit-icon-image--car-returned::before
.float-right--inline .suspicious-wrapper .visit-icon-image--visit-not-change-long::before {
    top: -1px;
}
.float-right--inline .suspicious-wrapper .visit-icon-image--changed-car-category::before {
    top: -1px;
    left: 1px;
}
.float-right--inline .visit-icon-image--exclamation::before {
    width: 21px;
    height: 16px;
}

.float-right--inline .suspicious-wrapper .visit-icon {
    width: 30px;
    font-size: 16.5px;
    text-align: center;
}

.float-right--inline .suspicious-wrapper .visit-icon-image--time::before {
    width: 16px;
    left: 2px;
    top: 1px;
}

.float-right--inline .suspicious-wrapper .visit-icon-image--arrow::before {
    width: 14px;
    left: 3px;
}

.no-margin {
    margin: 0 !important;
}
.no-margin-bottom, .no-margin-bottom>.nav-tabs {
    margin-bottom: 0 !important;
}
.no-padding-top {
    padding-top: 0;
}
.no-padding {
    padding: 0 !important;
}

.container {
    width: 100%;
    z-index: 1;
}
.container.loading, .loading {
    -webkit-filter: blur(15px);
    -moz-filter   : blur(15px);
    -ms-filter    : blur(15px);
    -o-filter     : blur(15px);
    filter        : blur(15px);
}

.underline {
    text-decoration: underline;
}

.empty {
    padding: 30px 0;
    text-align: center;
    font-size: 110%;
    color: #999;
}
.empty.empty-big {
    padding: 80px 0;
    font-size: 1.15em;
    color: #afafaf;
}

h1, .h1, h2, .h2, h3, .h3 {
    padding: 20px 0;
    margin: 0;
}
h2.bigheader {
    margin: 0;
    padding: 18px 20px;
    text-align: left;
    font-size: 16px;
    font-weight: 500;
    color: inherit;
    border-bottom: 1px solid var(--l12-delimiter-color, transparent);
}
h2, .h2 {
    font-size: 24px;
}
h1, .h1, .h3 {
    font-weight: 500;
}
h1, .h1 {
    padding-bottom: 26px;
    font-size: 26px;
}

.small-padding {
    padding-bottom: 20px;
}

.block {
    margin-bottom: 24px;
}

.block-mini {
    margin-bottom: 20px !important;
}
.overflow {
    overflow: hidden;
}
.transparent {
    background: transparent !important;
}
.z-up {
    position: relative;
    z-index: 10;
}
.z-3 { z-index: 3; }

.chartDays .google-visualization-tooltip {
    margin-top: 40px;
}
.chartManagers {
    /*margin-top: -17px;*/
}
.chartManagers .google-visualization-tooltip {
    margin-top: 55px;
}

.submenu-prerender {
    min-height: 48px;
    margin: 20px 0 15px;
}
.submenu-prerender.outer {
    margin-bottom: 0;
}
.submenu-prerender.inner {
    margin: 0;
}
.submenu-prerender .h3 {
    margin: 0;
}

.padding-0 {
    padding: 0 !important;
}

.graph-prerender {
    position: relative;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) -14px 16px no-repeat;
    height: 540px;
    margin-top: -45px;
}
.graph-prerender.mini {
    height: 300px;
}
.graph-prerender .inner {
    width: 100%;
    height: 100%;
    position: absolute;
}

table.graph-tooltip td { border: 1px lightgray solid; width: 33.3% }
table.graph-tooltip {  border: 2px white solid;; width: 100%; text-align: center; margin: 5px 0 }

.calendar-pager {
    height: 75px;
    margin-bottom: 20px;
    margin-top: 40px;
}
.calendar-pager.pure {
    height: auto;
    margin-bottom: 0;
}
.calendar-pager .btn-month {
    width: 150px;
    cursor: default;
    background: #fff !important;
    color: #000 !important;
    box-shadow: none !important;
    text-transform: uppercase !important;
}
.calendar-pager .btn-default {
    border-color: #f0f0f0;
}
.month-days {
    width: 250px;
}
.month-days > div:first-child {
    float: right;
    margin-right: 4px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.month-days .btn-group {
    margin-top: -1px;
}
.month-days span {
    text-align: center;
    width: 36px !important;
    padding: 6px 0 !important;
}

.camera-buttons .btn {
    margin: 0 10px 5px 0;
}
.camera-buttons {
    margin-bottom: 14px;
}

.c12cs-unsupported-fullscreen #notice-static,
.c12cs-unsupported-fullscreen .navbar,
.c12cs-unsupported-fullscreen .navbg {
    display: none !important;
}

.well {
    background: #fff;
    border: 0;
    box-shadow: none;
}

.navbar-inverse .navbar-nav>li>a {
    color: #efefef;
}

.panel-heading table, .panel-heading .table {
    background: transparent;
    margin: 0 -6px;
}

.btn-group .btn-default:active,
.btn-group .btn-default.active,
.visit-table tr.active,
.table > tbody > tr.active > td
{
    color: #000;
    background-color: rgba(var(--l12-gray-alt-color-rgb, 160, 160, 160), 0.1) !important;
    cursor: default;
    box-shadow: none;
}

.navbar-default .navbar-nav>li>a:hover, .navbar-default .navbar-nav>li>a:focus {
    background-color: #fcfcfc;
}

.navbar small {
    text-transform: none;
    font-size: 75%;
    display: block;
    height: 35px;
    margin-top: -5px;
}

/*график выделять не надо*/
.table-hover>tbody>tr[name="c-st-graph-row"]:hover {
    background-color: white;
}
#c-st-graph {
    position: relative;
    padding: 14px 0 0 0;
}
#c-st-graph>span.close{
    position: absolute; right: 10px; top: 24px; z-index: 100
}

input.ng-invalid.ng-dirty {
    border-color: #ff8f8f !important;
    background: #fff7f7 !important;
}

.modal {
    display: flex !important;
    display: -webkit-flex !important;
    padding: 24px;
}
.modal-dialog {
    margin: auto !important;
}
.modal-content {
    padding: 20px 24px;
}

/*костыли к графикам*/
.s svg>g>g g rect, .s svg>g>g g>g rect, .s svg>g>g g>g:last-child rect, .s svg>g>g g>g:first-child rect {
    cursor: pointer !important;
}
.s svg>g>g g:last-child rect, .s svg>g>g g:first-child rect {
    cursor: default !important;
}
.s svg>g>g>g>g>rect:last-child[fill-opacity="0"] {
    /*outline: 4px solid rgba(255, 0, 0, .5);*/
}

.s svg>g>g {
    cursor: pointer !important;
}

.google-visualization-tooltip {
    padding: 5px 15px !important;
}
.google-visualization-tooltip .tt1 {
    width: 200px;
}
.google-visualization-tooltip .tt2 {
    width: 150px;
}
.google-visualization-tooltip b {
    font-weight: normal;
    font-size: 115%;
}

.paging-wrap{
    text-align: center;
    clear: both;
}

.pagination .disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.visit-wrap {
    position: relative;
}
.visit-table tr {
    cursor: pointer;
}
.visit-table tr, .visit-table td {
    border: 0 !important;
}
.visit-col-left {
    width: 100%;
    padding-right: 660px;
}
.visit-col {
    width: 640px;
    position: absolute;
    top: 0;
    right: -10px;
    padding-bottom: 30px;
}

.visit-photo {
    text-align: center;
    margin: 0 0 25px;
    position: relative;
    border-radius: var(--l12-radius, 0);
    background: rgba(var(--l12-gray-alt-color-rgb, 0,0,0), 0.1) url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center center no-repeat;
    overflow: hidden;
    min-height: 340px;
}
.visit-photo img {
    display: block;
    max-width: 100%;
}
.visit-photo .camera-holder {
    position: absolute;
    padding: 30px;
    left: 0;
    right: 0;
    bottom: 0;
}
.camera-holder .empty {
    color: #b8bac0;
    background: transparent;
    backdrop-filter: blur(18px);
    font-style: normal;
    padding: 16px;
    border-radius: 18px;
}
.camera-holder .hider {
    display: none;
}

table.table-transparent, table.table-transparent td, table.table-transparent th {
    background: transparent;
    border-color: transparent !important;
}

.visit-table .visit-icon {
    display: inline-block;
    background: transparent;
    color: var(--l12-dark-color, #000);

    font-size: 1.2em;
    font-weight: 500;

    border-radius: 6px;
    padding: 2px 6px 2px;

    margin-left: 3px;
}

.visit-table .active .visit-icon {
    background: rgba(255, 255, 255, 0.6);
    color: var(--l12-dark-color, #000);
}

.visit-icon-image::before {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: contain;
}

.visit-icon-image--changed-group::before {
    width: 18px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.visit-icon-image--manual-number-input::before {
    height: 16px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.visit-icon-image--payment-canceled::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.visit-icon-image--exclamation::before {

    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.visit-icon-image--visit-not-change-long::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.visit-icon-image--car-returned::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.visit-icon-image--changed-car-category::before {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.visit-icon-image--time::before {
    width: 18px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.visit-icon-image--arrow::before {
    width: 14px;
    top: 55%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.red-text {
    color: var(--l12-danger, #f00);
}
.pink-text {
    color: #9E3C3D;
}

.visit-icon-set .visit-icon {
    padding: 0 2px;
}

.navbar {
    z-index: 10;
    position: relative;
}
.navbar-nav>li>a {
    padding-top: 14px;
    padding-bottom: 14px;
    border-radius: var(--l12-radius, 0);
}

.logo {
    padding: 0 !important;
    margin-left: 15px;
}
.logo img {
    width: 46px;
    height: 46px;
}

.rcBody .navbg {
    border-top-color: #00c853;
}

.caps, .wrap .navbar a {
    text-transform: uppercase;
}

.relative {
    position: relative
}

.btn {
    font-weight: 500;
}
.btn.btn-xs {
    font-weight: 500;
    min-width: 26px;
}
.btn.btn-lg {
    font-weight: 400;
}

.btn-group .btn {
    text-transform: none;
    font-size: 14px;
    font-weight: 400;
}

/*#region Camera */
.camera-toolbar {
    max-width: 1060px;
    padding: 16px 6px;
}

.camera-wrap {
    position: relative;
    z-index: 0;
    width: 100%;
    max-width: 1060px;
    overflow: hidden;
    background: #222;
    aspect-ratio: 16 / 9;
    border-radius: var(--l12-radius, 0);
}

.camera-wrap > * {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

#camplayer {
    z-index: 1;
}

#camera-loading {
    z-index: 2;
    display: none;
}
#camera-loading.load {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
#camera-loading .preloader {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) center center no-repeat;
    background-size: contain;
    height: 60px;
    width: 60px;
}

/* #camera-loading .inner, */
#camera-loading .bar,
#camera-loading .txt {
    /* NOTE: В новой версии дизайна и плеера их нет */
    display: none;
}
/*#endregion */

.videoLoader {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) center 100% no-repeat !important
}
.visit-photo .camera-holder .hider {
    width: 573px;
}

.payment-box {
    text-align: center;
    line-height: 150%;
    padding: 30px;
    margin-top: 20px;
    border: 1px solid black;
}

.wrap {
    min-height: 80vh;
    padding-bottom: 40px;
    background: var(--l12-bg-color, #fff);
}

textarea {
    max-width: 100%;
}
.focused {
    border-color: #66afe9;
    outline: 2px solid #66afe9;
}
input[type="password"].focused, input[type="text"].focused, input[type="number"].focused {
    background: #fff;
}

.supportMode .supportWrap {
    position: relative;
    overflow: auto;
    background: #fff;
    margin: 0 auto;
}
.supportMode .supportWrap .wrap {
    padding-bottom: 3000px;
}
.supportMode {
    background: #ccc;
}
.supportMode .navbg {
    display: none;
}
.btn-rc {
    position: absolute;
    top: 4px;
    right: 2px;
}


.navbar-right {
    margin-right: 0;
}


.pointer, .cursor--pointer {
    cursor: pointer;
}

.to-save,
.to-cancel {
    display: none;
}
.to-save, .to-cancel, .to-remove {
    position: relative;
}

.to-remove, .to-add {
    font-size: 16px !important;
    line-height: 16px !important;
}

.to-remove-category {
    position: absolute;
    right: -1px;
    top: calc(50% - 11px);
    font-size: 14px;
    line-height: 1em;
    border: none;
    background: rgba(var(--l12-dark-color-rgb, 0,0,0), 0.3);
    color: rgba(255, 255, 255, 0.8);
    padding: 0;
    border-radius: 100px;
    height: 20px;
    width: 20px;
    text-align: center;
    backdrop-filter: blur(6px);
}
.to-remove-category:hover {
    opacity: 1;
    background: var(--l12-danger, #f00);
    color: #fff;
}

.ng-dirty .to-save, .ng-dirty .to-cancel, .new .to-save, .new .to-cancel  {
    display: inline-block;
}
tr.ng-dirty,
tr.ng-dirty .table,
tbody.ng-dirty tr,
.new,
div.new .panel-heading,
div.ng-dirty .panel-heading,
.block--editable.ng-dirty textarea {
    background: #F2F5F9 !important;
}
.ng-dirty input, .new input, div.new .panel-heading input, div.ng-dirty .panel-heading input {
    background: #FFFFFF;
}
.ng-dirty .onlyDirty {
    display: inline-block !important;
}

.to-remove {
    opacity: .3;
    margin-left: 16px;
    padding: 3px 4px 1px 3px;
}
tr:hover .to-remove {
    opacity: 1;
}

.to-add {
    opacity: .3;
}
tr:hover .to-add {
    opacity: 1;
}

.table, table {
    background: #fff;
}

input[disabled] {
    cursor: not-allowed !important;
}

.editor-column, .editor-column-child {
    width: 180px;
}
.editor-column-child, .editor-column {
    text-align: right;
}
.table-editable-small {
    margin-bottom: 0;
}
.table-editable-small td, .table-editable-small th {
    border-top: 0 !important;
}

.table-editable__actions .btn {
    font-size: 12px;
    padding: 2px 5px 2px;
    min-width: 26px;
    margin-top: -2px;
    margin-bottom: -2px;
}

.one-tab .nav.nav-pills {
    display: none;
}

.chart-type {
    position: absolute;
    right: 70px;
}

.activate {
    margin: 100px 0 0 30%;
}
.activate div {
    margin-bottom: 40px;
}
.activate .btn-success {
    text-transform: none;
    font-size: 20px;
    line-height: 45px;
    padding: 10px 36px;
}
.activate h1 {
    font-size: 37px;
}
.activate p {
    font-size: 17px;
}

.num {
    border: 1px solid #444;
    padding: 0 3px 0 4px;
    border-radius: 4px;
    background: #fdfdfd;
    text-decoration: none !important;
}
a.num:hover {
    background: #e2e2ff;
}
.num .n4 {
    border-left: 1px solid #444;
    padding-left: 3px;
}
.num .n3 {
    padding-right: 4px;
}
.num .n2 {
    padding: 0 1px 0 2px;
}
.num .n1, .num .n3 {
    font-size: 85%;
}
.table-prices .max-value {
    margin-top: 3px;
}
.table-prices .first {
    width: 19%;
}
.table-prices.table-small tr th.mini,
.table-prices.table-small tr td.mini {
    padding: 8px 6px;
}
.table-prices.table-small .first {
    width: 20%;
}
.table-prices .for-icon {
    width: 3%;
}
.table-movable:hover {
    cursor: move;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}

.tosort .connected tr {
    cursor: move;
}
.table>tbody+tbody {
    border-top: 0;
}
tr.new, tr.ng-dirty {
    cursor: default !important;
}
.emptyCategory {
    height: 30px;
}
.emptyCategory:before {
    content: " ";
}

.empty-visit-text {
    background-color: rgba(0,0,0,.5);
    padding: 2px 10px;
    line-height: 25px;
}

/* Common */

.c-icon-text {
    font-weight: bold;
    font-size: 110%;
    cursor: default;
}
.c-icon-big {
    font-size: 2em;
}
.margin-left-5 { margin-left:5px; }
.margin-left-10 { margin-left:10px; }
.margin-left-15 { margin-left:15px; }
.margin-top-5 { margin-top:5px; }
.margin-top-10 { margin-top:10px; }
.margin-top-15 { margin-top:15px; }
.margin-top-25 { margin-top:25px; }
.margin-top-70 { margin-top:70px; }
.margin-right-5 { margin-right:5px; }
.margin-right-10 { margin-right:10px; }
.margin-right-15 { margin-right:15px; }
.margin-bottom-5 { margin-bottom:5px; }
.margin-bottom-10 { margin-bottom:10px; }
.margin-bottom-15 { margin-bottom:15px; }
.margin-bottom-30{
    margin-bottom: 30px;
}
.width30 { width:30% }
.width50 { width:50% }
.width70 { width:70% }
.c-display-table
{
    display: table;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
}
.c-display-table .c-display-cell
{
    display: table-cell;
    vertical-align: middle;
}
.hcenter
{
    margin-left: auto;
    margin-right: auto;
}
.cell-valign-middle {
    vertical-align: middle !important;
}


/* Analytics & Incomes */

.c-i-btn-dashed.btn-xs {
    border-bottom: 1px dashed #ccc;
}


/* Alarms*/

tr.c-alarm-entry {
    cursor: pointer;
}
tr.c-alarm-entry-new {
    background-color: #fcf8e3;
}
tr.c-alarm-entry td{
    vertical-align:middle !important;
    text-align: center;
}
tr.c-alarm-entry td.alarm-pic{
    width:1%;
}
.c-alarm-entry img, .c-alarm-entry .noimg {
    width: 50px;
    height: 50px;
}
.c-alarm-entry .noimg {
    display: inline-block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) center center no-repeat;
    background-size: 100% 100%;;
}


/* Alarm modal dialog*/
.c-alarm-modal-window .modal-dialog {
    width: 662px;
    margin-top: 40px;
    padding: 0px;
}
.c-alarm-modal-window .modal-dialog .modal-content .modal-body{
    padding: 0px;
}
.c-alarm-modal-window .modal-dialog .modal-content .modal-body .row{
    padding: 0px;
}
.c-alarm-modal-window .modal-dialog .modal-content .modal-body .close{
    position: absolute;
    right: -18px;
    top: -12px;
}
.c-alarm-modal-window img, .c-alarm-modal-window .noimg {
    max-width: 640px;
    max-height: 480px;
}
.c-alarm-modal-window .camera-preview {
    width: 640px;
    height: 480px;
}
.c-alarm-modal-window .no-preview {
    background-color: #000000;
}
.c-alarm-modal-window-table{
    width: 90%;
    margin: 0 auto;
}
.c-alarm-modal-window-table tr{
    vertical-align:middle !important;
}

.download-report-modal-window .modal-dialog {
    width: 700px;
}

div.number-format-hint{
    width: 136px;
    text-align: center
}

div.index-summary {
    position: relative;
}
div.index-summary .filterable {
    cursor: pointer;
    font-weight: normal;
    color: #E78774;
}
div.index-summary .filterable.active-filter {
    font-weight: bold;
}
div.index-summary > h6 {
    margin-bottom: 30px;
}
div.index-summary table {
    margin-bottom: 0;
}
/*
.table th>small {
    font-weight: normal;
}*/

.rub{
    display: inline-block;
    line-height: 5px;
    border-bottom: 1px solid #000000;
    width: 0.4em;
}

.panel-pribluding {
    width: 240px;
    padding: 20px 20px 18px;
    text-align: center;
}

.panel-pribluding-center {
    margin: 0 auto 40px;
}

.rating-wrapper {
    font-size: 1.5em;
    color: #f8d33a;
    white-space: nowrap
}

.login-error {
    color: var(--l12-danger, #f00);
    margin: 10px 0 10px 0;
}

.generate-error{
    color: var(--l12-danger, #f00);
    margin: 10px 0 10px 0;
}

.generate-success{
    color: var(--l12-green-color, #008000);
    margin: 10px 0 10px 0;
}

.login-block {
    width: 350px;
    margin-top: 9%;
    margin-left: -175px;
    left: 50%;
    position: absolute;
}

.login-logo {
    text-align: center;
    margin-bottom: 15px;
}

.login-logo img {
    width: 200px;
    height: auto;
}

.center-block {
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.sk3 path.sk3-line {
    stroke-width: 0;
}

.sk3-area:hover, .sk3-target:hover .sk3-area {
    opacity: .7;
}

.sk3-target {
    cursor: pointer;
}

.chart-legends__item {
    display: inline-block;
    margin-right: 12px;
}

.chart-legends__item:last-child {
    margin-right: 0;
}

.chart-legends__label {
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 4px;
}

.chart-legends__caption {
    display: inline-block;
    font-size: 12px;
}

.nav-pills--flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.nav-checkbox {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

.nav-checkbox > li,
.nav-pills--flex > li {
    float: none;
    flex: auto 0 0;
    margin: 0 8px 8px 0 !important;
}

.btn-active {
    color: #fff;
    background-color: #9f9f9f !important;
    box-shadow: none;
}

.c12-indicator-status {

}

.c12-indicator-status--online {
    color: var(--l12-green-color, #008000);
}

.c12-indicator-status--offline {
    color: var(--l12-danger, #f00);
}

.icon {
    fill: currentColor; }

.icon-close {
    width: 1em;
    height: 1em; }

.btnForm {
    height: 62px;
    padding: 0 50px;
    background: #0e4a82;
    border-radius: 30px;
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 700;
    color: #FFF;
    -webkit-transition: background .2s;
    transition: background .2s;
    border: 2px solid #0e4a82;
}
@media only screen and (max-width: 1900px) {
    .btnForm {
        height: 52px;
        font-size: 15px; } }
@media only screen and (max-width: 1023px) {
    .btnForm {
        height: 62px;
        font-size: 16px; } }
.btnForm:hover {
    background: #0f518f; }

.popup {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 50px 20px;
    background: rgba(37, 37, 38, 0.6);
    overflow: auto;
    -webkit-transition: all .2s;
    transition: all .2s;
    text-align: center;
    font-size: 0;
    z-index: 999; }
.popup:before {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 100%; }
@media only screen and (max-width: 1279px) {
    .popup .btnForm {
        font-size: 14px; } }
@media only screen and (max-width: 799px) {
    .popup {
        padding: 50px 10px; } }
@media only screen and (max-width: 320px) {
    .popup {
        padding: 0 5px; } }
@media only screen and (max-width: 1023px) {
    .popup .btnForm {
        height: 52px; } }
.popup.active {
    display: block; }
.popup__center {
    display: inline-block;
    position: relative;
    width: 90%;
    margin: 5%;
    max-width: 690px;
    border-radius: 3px;
    vertical-align: middle;
    font-size: 14px;
    text-align: left; }
@media only screen and (max-width: 1900px) {
    /*.popup__center {
      max-width: 510px; } */
}
@media only screen and (max-width: 1279px) {
    /*.popup__center {
      max-width: 450px; }*/
}
.popup__close {
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 12px;
    padding-right: 9px;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.46);
    -webkit-transition: color .2s;
    transition: color .2s;
    z-index: 2; }
@media only screen and (max-width: 1023px) {
    .popup__close {
        padding-top: 8px;
        padding-right: 9px; } }
.popup__close:hover {
    color: rgba(0, 0, 0, 1); }
.popup__close .icon {
    font-size: 16px; }
@media only screen and (max-width: 1023px) {
    .popup__close .icon {
        font-size: 12px; } }
.popup__wrap {
    position: relative;
    width: 690px;
    padding: 0px 0px 0px;
}

@media only screen and (max-width: 1279px) {
    .popup__wrap {
        padding: 0px 55px 60px;
        width: 100%;
    }
}
@media only screen and (max-width: 419px) {
    .popup__wrap {
        padding: 0px 25px 60px; } }
@media only screen and (max-width: 374px) {
    .popup__wrap {
        padding: 0px 15px 30px; } }

.share .popup__center {
    max-width: 690px;
    line-height: 0.5;
}

.share-1 .popup__center{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat white;
}

.share .popup__center li {
    line-height:1;
    color: orange;
    font-size: 35px;
}

.share .popup__center li span {
    color: #333333;
    font-size: 22px;
}

.share .popup__center ul {
    padding-top: 10px;
}

.share-left {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: 50%;
    float:left;
    font-weight: 600;

    padding: 20px;
}

.share-right {
    width: 43%;
    float:left;
    padding-bottom: 34px;
    padding-right: 50px;
}

.share .btnForm {
    height: 48px;
    padding: 0px;
}

.share-1 .form__field {
    margin-bottom: 15px;
}

.share__wrap {
    padding: 20px 20px 82px 30px;
}

.display {
    display: none;
}

.share__title {
    font-size: 22px;
    text-align: left;
    padding-top: 17px;
}

.thank {
    display: none;
    padding-top: 10px;
    text-align: center;
    line-height: 1;
    font-size: 18px;
}
@media only screen and (max-width: 1900px) {
    .thank {
        padding-top: 10px; } }
.thank__title {
    font-size: 22px;
    padding-bottom: 7px;
}
@media only screen and (max-width: 1900px) {
    .thank__title {
        font-size: 22px; } }
@media only screen and (max-width: 1900px) {
    .thank__content {
        font-size: 18px; } }
.form__wrap {
    max-width: 690px;
    margin: 0 auto; }

.form__wrap .btnForm {
    height: 44px;
}

.form__wrap .form__field input {
    height: 44px;
}

.form__field {
    margin-bottom: 30px;
    float:left;
    width: 33%;
    padding-left:1px;
    padding-right:5px;
}

.form__field .error {
    border-color: var(--l12-danger, #f00);
}

.form__field_btn {
    padding-right:0px;
}
@media only screen and (max-width: 320px) {
    .form__field {
        margin-bottom: 15px; } }

.form__field .form__input, .form__field .btnForm {
    font-size: 16px;
}

@media only screen and (max-width: 1900px) {
    .form__field {
        float:left;
        width: 30%;
    } }
@media only screen and (max-width: 800px) {

    .form__field {
        float:none;
        width: 100%;
        padding-top: 10px;
    }

    .form__wrap {
        max-width: 450px;
        margin: 0 auto;
    }

    .form__field .form__input, .form__field .btnForm {
        font-size: 15px;
    }
}
.form__input {
    width: 100%;
    height: 62px;
    border: 2px solid #e6e6e6;
    border-radius: 30px;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    background-color: white;
    border-color: #0e4a82;
}
.form__input:-moz-placeholder, .form__input::-moz-placeholder {
    color: #bdbdbd;
    opacity: 1; }
.form__input::-webkit-input-placeholder {
    color: #bdbdbd; }
@media only screen and (max-width: 1900px) {
    .form__input {
        height: 52px;
        font-size: 15px; } }
@media only screen and (max-width: 1279px) {
    .form__input {
        font-size: 14px; } }
@media only screen and (max-width: 320px) {
    .form__input {
        height: 40px; } }

.form__btn {
    width: 100%; }


@media only screen and (max-width: 1900px) {
    .share__title {
        font-size: 20px;
    }

}

.share__wrap_thank {
    padding: 20px 20px 20px 30px;
}


.share .checkbox {
    vertical-align: top;
    margin: 0 3px 0 0;
    width: 17px;
    height: 17px;
}

.share .checkbox + label {
    cursor: pointer;
}

.share .checkbox:not(checked) {
    position: absolute;
    opacity: 0;
}
.share .checkbox:not(checked) + label {
    position: relative;
    padding: 0 0 0 60px;
    padding-right: 10px;
}

.share .checkbox:not(checked) + label:before {
    content: '';
    position: absolute;
    top: -4px;
    left: 0;
    width: 50px;
    height: 26px;
    border-radius: 13px;
    background: #CDD1DA;
    box-shadow: inset 0 2px 3px rgba(0,0,0,.2);
}

.demo__stand_title {
    position: fixed;
    left: 0px;
    background-color: var(--l12-danger, #f00);
    color: white;
    font-size: 14px;
    z-index: 3000;
    font-weight: 500;
    padding: 10px 30px 10px 20px;
    border-bottom-right-radius: 18px;
    user-select: none;
}


.share .checkbox:not(checked) + label:after {
    content: '';
    position: absolute;
    top: -2px;
    left: 2px;
    width: 22px;
    height: 22px;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 0 2px 5px rgba(0,0,0,.3);
    transition: all .2s;
}


.share .checkbox:checked + label:before {
    background: #0e4a82;
}

.share .checkbox:checked + label:after {
    left: 26px;
}

@media only screen and (max-width: 810px) {
    .share .popup__center {
        max-width: 333px;
        line-height: 1;
    }

    .share-2 .popup__center {
        max-width: 333px;
    }

    .share__title {
        font-size: 18px;
    }

    .share .popup__center li {
        line-height: 1;
        font-size: 35px;
    }

    .share .popup__center li span {
        font-size: 18px;
    }

    .share-1 .share__wrap {
        padding: 20px 20px 134px 30px;
    }

    .share-1 .popup__center {
        max-width: 333px;
        line-height: 1;
    }

    .share-1 .popup__center {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat white;
    }

    .share-left, .share-right {
        width: 100%;
        float: none;
    }
}

.modal-content .tab-content {
    margin-top: 16px;
}

.dropdown-menu > li:hover {
    cursor: pointer;
}

.input-group-btn select {
    border-color: #ccc;
    height: 34px;
}

.input-group-btn select.btn-default:focus {
    background: #fff;
}

a.filterable {
    color: #1170ac;
}

a.filterable.active {
    font-weight: bold;
}

.table-tree__node {
    cursor: pointer;
}

.table-tree__node {
    transition: all linear 0.25s;
}
.table-tree__node.ng-hide {
    opacity: 0;
}

.table-tree__node--level1 td:first-child {
    padding-left: 12px;
}

.table-tree__node--level2 td:first-child {
    padding-left: 24px;
    font-style: italic;
}

.visible-important {
    display: block !important;
}

.label-primary {
    background-color: #337ab7;
}

.margin-bottom-0 {
    margin-bottom: 0!important;
}

.list-expand {
    position: relative;
    width: 15px;
    height: 10px;
    padding: 0;
    margin-right: 5px;
    background: transparent;
    border: 0;
    outline: none;
}

.list-expand::before {
    content: '';
    position: relative;
    top: 1px;
    left: 2px;
    display: block;
    width: 8px;
    height: 8px;
    border-top: 2px solid currentColor;
    border-left: 2px solid currentColor;
    transform: rotate(45deg);
}
.list-expand.expanded::before {
    transform: rotate(-135deg);
    top: -1px;
}

.suspicious-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
    padding-left: 24px;
}

.event-description {
    max-width: 85%;
}

.event-confirm-container {
    margin-left: auto;
}

.suspicious-event__btn {
    float: left;
    position: relative;
    top: -2px;
    border: 0;
    background-color: transparent;
    color: currentColor;
    font-size: 19px;
    cursor: pointer;
    transition: color 200ms;
    opacity: 0.8;
}

.suspicious-event__btn:hover,
.suspicious-event__btn:focus {
    color: #222;
    opacity: 1;
}

.event--confirmed {
    color: #42a956;
}

.button-expand::before {
    content: '';
    position: absolute;
    display: block;
    width: 9px;
    height: 9px;
    top: 50%;
    left: 50%;
    border-left: 3px solid #000;
    border-bottom: 3px solid #000;
    transform-origin: 50% 50%;
    transform: translate(-50%, -50%) rotate(-45deg);
}

.button-expand--expanded::before {
    transform: translate(-50%, -50%) rotate(135deg);
    top: 15px;
}

.average-profits-expand {
    position: relative;
    margin-right: 5px;
    padding: 0;
    border: 0;
    background-color: transparent;
    outline: none;
}

.average-profits-expand::before {
    content: '';
    display: block;
    position: relative;
    top: -3px;
    width: 8px;
    height: 8px;
    border-left: 2px solid #000;
    border-bottom: 2px solid #000;
    border-radius: 2px;
    transform: rotate(-45deg);
}

.average-profits-expand--expanded::before {
    transform: rotate(135deg);
    top: 0;
}

.station-name {
    padding-left: 35px;
}

table>tbody>tr>.table-cell--border-white { /* чтобы точечно перебить бутстраповский стиль */
    border-color: #fff;
}

.report-label {
    float: left;
}

.report-label__text {
    margin-right: 10px;
}

.report-label__input {
    display: inline-block;
    vertical-align: top;
}

.report-btn-wrapper {
    text-align: left;
}

.report-btn {
    margin-left: 24.9em;
}

.ratings-icon {
    display: block;
    width: 20px;
    height: 20px;
    margin: 0 auto;
    background-position: 50% 50%;
    -webkit-background-size: contain;
    background-size: contain;
    background-repeat: no-repeat;
}
.ratings-icon--total {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.ratings-icon--reviews {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}
.ratings-icon--normative {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.ratings-icon--check {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.happysmail-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}

.nhappysmail-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}

.neutralsmail-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}

.nsadsmail-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.sadsmail-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.ratings-icon--productivity,
.ratings-icon--time {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}

.ratings-icon--suspicious {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}

.ratings-cell {
    text-align: center;
}

.ratings-cell-error {
    text-align: center;
    color: var(--l12-danger, #f00);
}

.discount {
    position: relative;
}

.discount__row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
}

.discount__row:last-child {
    margin-bottom: 0;
}

.discount__label {
    text-align: right;
}

.discount__input {
    width: 273px;
}

.discount__input,
.discount__label {
    margin-right: 10px;
}

.discount__small {
    display: block;
}

.discount__btn {
    margin-left: auto;
    margin-right: 300px;
}

.discount__upload-result {
    text-align: center;
}

.discount__link {
    text-decoration: underline;
}

.client-app {
    margin-left: 10px;
    padding-top: 6px;
}

.client-app__label-text {
    vertical-align: text-bottom;
    color: rgba(51, 51, 51, .65);
    font-weight: 400;
}

.analytic-controls {
    width: 100%;
    margin-bottom: 24px;
    border-bottom: 1px solid #ddd;
}

.analytic-controls .btn {
    margin-bottom: 24px;
}

.table--analytic>tbody:nth-child(odd)>tr.table__parent-row {
    background: #f7f7f7;
}

.table--analytic>tbody:nth-child(even)>tr.table__parent-row {
    background: #fff;
}

.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(even) {
    background: #fcfcfc;
}

.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(odd) {
    background: #fff;
}
.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(odd):hover,
.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(odd):focus,
.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(even):hover,
.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(even):hover {
    background: #f7f7f7;
}

.table--analytic>tbody:nth-child(even)>tr.table__parent-row+tr:hover,
.table--analytic>tbody:nth-child(even)>tr.table__parent-row+tr:focus {
    background: #f7f7f7;
}

.table--analytic>tbody:nth-child(even)>tr.table__parent-row:hover,
.table--analytic>tbody:nth-child(even)>tr.table__parent-row:focus,
.table--analytic>tbody:nth-child(odd)>tr.table__parent-row:hover,
.table--analytic>tbody:nth-child(odd)>tr.table__parent-row:focus {
    background: #f1f1f1;
}

.table--analytic th,
.table--analytic td {
    width: 14%;
}

.table--analytic td {
    max-width: 216px;
    overflow-wrap: break-word;
}

.table__body--hide-children .table__child-row {
    display: none;
}

.table__parent-row {
    cursor: pointer;
}

.table__child-name {
    display: block;
    padding-left: 24px;
    font-style: italic;
}

.table--analytic .table__row--borderless {
    background: #f7f7f7;
}

.table--analytic .table__row--borderless th{
    border-bottom: none;
}

.point-filter {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

th.orderBy {
    cursor: pointer;
}
th.orderBy:after {
    font-family: 'Glyphicons Halflings';
    content: "\\e150";
    position: relative;
    top: 1px;
    display: inline-block;
    font-style: normal;
    font-weight: normal;
    line-height: 1;
    margin-left: 3px;
    font-size:10px;
    opacity:0
}

th.orderBy:hover::after {
    opacity: 1
}

/*#region Mobile adaptive*/
:root {
    --app-btn-border-radius: 5px;
}

.c-mb-2 { margin-bottom: 20px !important; }
.c-mb-3 { margin-bottom: 30px !important; }

.login-block .form-control::placeholder {
    color: transparent;
}

@media screen and (max-width: 767px) {
    .wrap {
        padding-bottom: 0;
        padding-top: var(--l12-head-offset, 80px);
    }

    .no-adaptive-wrap {
        min-width: 768px;
    }

    /*#region Login page */
    .login-block {
        margin-top: 14vh;
        max-width: 300px;
        max-width: 260px;
        left: 0;
        margin: 0 auto;
        position: relative;
    }
    .login-block .btn {
        width: 100% !important; /* style="width: 120px;" */
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .login-block .form-control {
        padding-top: 9px;
        padding-bottom: 9px;
        height: 40px;
    }

    .login-block label {
        display: none;
    }

    .login-block .form-control::placeholder {
        color: #555;
    }

    .login-block form > * {
        margin-top: 0 !important;
        margin-bottom: 16px;
    }

    .login-logo {
        padding-top: calc(10vh - 100px);
        padding-bottom: calc(15vh - 100px);
    }

    .login-logo img {
        max-width: 150px;
    }
    /*#endregion Login page */

    .calendar-pager {
        margin-bottom: 0;
        margin-top: 50px;
        display: inline-block;
        height: auto;
    }

    #chart-month {
        margin-top: -42px !important;
    }
    #chart-month > .btn {
        margin-right: 0 !important;
    }

    #chart-detailed .sk3,
    #chart-month .sk3 {
        overflow-x: auto;
        width: 100%;
    }

    .bigheader .pull-right {
        float: none !important;
        display: flex;
        flex-wrap: wrap;
        padding-top: 10px;
    }
    .bigheader .pull-right > * {
        margin-bottom: 4px;
        margin-left: 0 !important;
        margin-right: 4px;
    }

    /* ---- */

    .table-striped tr {
        background: #fff;
    }

    .index-summary .table tr th,
    .index-summary .table tr td {
        min-width: 140px;
        padding-top: 8px;
        padding-bottom: 8px;
    }

    .index-summary .table tr th:first-child,
    .index-summary .table tr td:first-child {
        position: -webkit-sticky;
        position: sticky;
        left: 0;
        background: #fff;
    }

    .index-summary .table tr.active > td:first-child {
        background-color: #f5f5f5;
    }

    /*#region Обратная связь */
    .issue-popup {
        min-height: calc(100vh - 21px * 2);
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .issue-popup .btn {
        display: block;
        width: 100%;
        margin-bottom: 20px;
        padding-top: 14px;
        padding-bottom: 14px;
    }
    /*#endregion Обратная связь */
}
/*#endregion*/

.filters__item {
    display: inline-block;
    padding-right: 10px;
    vertical-align: top;
}
.filters__item.top {
    vertical-align: top;
}

.filters__item .form-control {
    display: inline-block;
}

/**
    fixed окно в клиента / рассылках с количеством выбранных
 */
.c12-toggle-all-window {
    position: fixed;
    bottom: 0;
    left: 50%;
    background: #fff;
    padding: 20px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
    width: 440px;
    margin: 0 0 30px -220px;
    z-index: 10;
    border-radius: var(--l12-radius, 0);
}
.c12-toggle-all-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.c12-toggle-all-inner button {
    outline: none;
}
.c12-toggle-all-btns {
    text-align: center;
}
.c12-toggle-all-btns .btn {
    margin: 2px 0;
}
@media screen and (max-width: 600px) {
    .c12-toggle-all-window {
        width: 300px;
        margin-left: -150px;
    }
    .c12-toggle-all-inner {
        flex-direction: column;
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/legacy/styles/common.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;AACA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,SAAS;AACb;;AAEA;;IAEI,SAAS;AACb;AACA;IACI,SAAS;IACT,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,cAAc;AAClB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gEAAgE;AACpE;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA,OAAO,UAAU,EAAE;;AAEnB;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,wEAA4D;IAC5D,aAAa;IACb,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA,yBAAyB,2BAA2B,EAAE,aAAa;AACnE,uBAAuB,uBAAuB,GAAG,WAAW,EAAE,kBAAkB,EAAE,cAAc;;AAEhG;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;IAC3B,oCAAoC;AACxC;AACA;IACI,qBAAqB;AACzB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;AACjC;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;;;;IAKI,WAAW;IACX,oFAAoF;IACpF,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA,0BAA0B;AAC1B;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,kBAAkB,EAAE,WAAW,EAAE,SAAS,EAAE;AAChD;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,gCAAgC;IAChC,aAAa;AACjB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;;AAEA,qBAAqB;AACrB;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,2HAAwH;IACxH,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,SAAS;AACb;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,kCAAkC;;IAElC,gBAAgB;IAChB,gBAAgB;;IAEhB,kBAAkB;IAClB,oBAAoB;;IAEpB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,yDAA0D;AAC9D;;AAEA;IACI,YAAY;IACZ,yDAAgE;AACpE;;AAEA;IACI,yDAA6D;AACjE;;AAEA;;IAEI,yDAAwD;AAC5D;;AAEA;IACI,yDAA+D;AACnE;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,yDAAyE;AAC7E;;AAEA;IACI,WAAW;IACX,yDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,0DAAuD;AAC3D;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,mCAAmC;AACvC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,mCAAmC;AACvC;;AAEA;IACI,6BAA6B;IAC7B,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,4EAAwE;IACxE,wBAAwB;IACxB,YAAY;IACZ,WAAW;AACf;;AAEA,4BAA4B;AAC5B;;IAEI,iDAAiD;IACjD,aAAa;AACjB;AACA,cAAc;;AAEd;IACI;AACJ;AACA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,0BAA0B;AAC9B;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;;AAGA;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,uDAAuD;IACvD,+BAA+B;IAC/B,UAAU;IACV,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,UAAU;IACV,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;AACA;;;;;;;IAOI,8BAA8B;AAClC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,wBAAwB;AAC5B;AACA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;AACA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,UAAU;AACd;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,WAAW;;AAEX;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;IACI,cAAc;AAClB;AACA,iBAAiB,eAAe,EAAE;AAClC,kBAAkB,gBAAgB,EAAE;AACpC,kBAAkB,gBAAgB,EAAE;AACpC,gBAAgB,cAAc,EAAE;AAChC,iBAAiB,eAAe,EAAE;AAClC,iBAAiB,eAAe,EAAE;AAClC,iBAAiB,eAAe,EAAE;AAClC,iBAAiB,eAAe,EAAE;AAClC,kBAAkB,gBAAgB,EAAE;AACpC,mBAAmB,iBAAiB,EAAE;AACtC,mBAAmB,iBAAiB,EAAE;AACtC,mBAAmB,iBAAiB,EAAE;AACtC,oBAAoB,kBAAkB,EAAE;AACxC,oBAAoB,kBAAkB,EAAE;AACxC;IACI,mBAAmB;AACvB;AACA,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB,WAAW,UAAU;AACrB;;IAEI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;;IAEI,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;;IAEI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,iCAAiC;AACrC;;;AAGA,wBAAwB;;AAExB;IACI,8BAA8B;AAClC;;;AAGA,UAAU;;AAEV;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,QAAQ;AACZ;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,qBAAqB;IACrB,4EAAgE;IAChE,0BAA0B;AAC9B;;;AAGA,sBAAsB;AACtB;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,UAAU;IACV,cAAc;AAClB;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;;;EAGE;;AAEF;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB,EAAE;;AAExB;IACI,UAAU;IACV,WAAW,EAAE;;AAEjB;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,kCAAkC;IAClC,0BAA0B;IAC1B,yBAAyB;AAC7B;AACA;IACI;QACI,YAAY;QACZ,eAAe,EAAE,EAAE;AAC3B;IACI;QACI,YAAY;QACZ,eAAe,EAAE,EAAE;AAC3B;IACI,mBAAmB,EAAE;;AAEzB;IACI,aAAa;IACb,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY,EAAE;AAClB;IACI,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,QAAQ;IACR,YAAY,EAAE;AAClB;IACI;QACI,eAAe,EAAE,EAAE;AAC3B;IACI;QACI,kBAAkB,EAAE,EAAE;AAC9B;IACI;QACI,cAAc,EAAE,EAAE;AAC1B;IACI;QACI,YAAY,EAAE,EAAE;AACxB;IACI,cAAc,EAAE;AACpB;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,gBAAgB,EAAE;AACtB;IACI;2BACuB;AAC3B;AACA;IACI;0BACsB;AAC1B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,qBAAqB;IACrB,UAAU,EAAE;AAChB;IACI;QACI,gBAAgB;QAChB,kBAAkB,EAAE,EAAE;AAC9B;IACI,uBAAuB,EAAE;AAC7B;IACI,eAAe,EAAE;AACrB;IACI;QACI,eAAe,EAAE,EAAE;AAC3B;IACI,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI;QACI,sBAAsB;QACtB,WAAW;IACf;AACJ;AACA;IACI;QACI,sBAAsB,EAAE,EAAE;AAClC;IACI;QACI,sBAAsB,EAAE,EAAE;;AAElC;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oEAAiE;AACrE;;AAEA;IACI,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,UAAU;IACV,UAAU;IACV,gBAAgB;;IAEhB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,UAAU;IACV,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;AACA;IACI;QACI,iBAAiB,EAAE,EAAE;AAC7B;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI;QACI,eAAe,EAAE,EAAE;AAC3B;IACI;QACI,eAAe,EAAE,EAAE;AAC3B;IACI,gBAAgB;IAChB,cAAc,EAAE;;AAEpB;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,mBAAmB,EAAE,EAAE;;AAE/B;IACI,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,UAAU;IACd,EAAE;AACN;;IAEI;QACI,UAAU;QACV,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,UAAU,EAAE;AAChB;IACI,cAAc,EAAE;AACpB;IACI;QACI,YAAY;QACZ,eAAe,EAAE,EAAE;AAC3B;IACI;QACI,eAAe,EAAE,EAAE;AAC3B;IACI;QACI,YAAY,EAAE,EAAE;;AAExB;IACI,WAAW,EAAE;;;AAGjB;IACI;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI,4BAA4B;AAChC;;;AAGA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,SAAS;IACT,yCAAyC;IACzC,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,gCAAgC;IAChC,iBAAiB;AACrB;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,oEAAuE;IAC3E;;IAEA;QACI,WAAW;QACX,WAAW;IACf;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,mCAAmC;IACnC,wBAAwB;AAC5B;AACA;IACI,0BAA0B;IAC1B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,WAAW;IACX,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;IAC/C,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,6BAA6B;IAC7B,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,MAAM;AACV;;AAEA;IACI,kBAAkB;AACtB;;AAEA,2CAA2C,gDAAgD;IACvF,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,cAAc;IACd,4BAA4B;IAC5B,gCAAgC;IAChC,wBAAwB;IACxB,4BAA4B;AAChC;AACA;IACI,0DAAkD;AACtD;AACA;IACI,0DAAoD;AACxD;AACA;IACI,0DAAsD;AAC1D;AACA;IACI,0DAAkD;AACtD;AACA;IACI,0DAA2D;AAC/D;;AAEA;IACI,0DAA4D;AAChE;;AAEA;IACI,0DAA6D;AACjE;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI,0DAAyD;AAC7D;;AAEA;;IAEI,0DAAyD;AAC7D;;AAEA;IACI,0DAAuD;AAC3D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;AACA;;;;IAII,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;;;IAII,mBAAmB;AACvB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;AACA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd;AACJ;;AAEA;IACI;AACJ;;AAEA,0BAA0B;AAC1B;IACI,4BAA4B;AAChC;;AAEA,UAAU,8BAA8B,EAAE;AAC1C,UAAU,8BAA8B,EAAE;;AAE1C;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;QACjB,yCAAyC;IAC7C;;IAEA;QACI,gBAAgB;IACpB;;IAEA,sBAAsB;IACtB;QACI,gBAAgB;QAChB,gBAAgB;QAChB,gBAAgB;QAChB,OAAO;QACP,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,sBAAsB,EAAE,0BAA0B;QAClD,iBAAiB;QACjB,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,wBAAwB;QACxB,mBAAmB;IACvB;;IAEA;QACI,+BAA+B;QAC/B,kCAAkC;IACtC;;IAEA;QACI,gBAAgB;IACpB;IACA,yBAAyB;;IAEzB;QACI,gBAAgB;QAChB,gBAAgB;QAChB,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,4BAA4B;IAChC;IACA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,iBAAiB;IACrB;;IAEA,SAAS;;IAET;QACI,gBAAgB;IACpB;;IAEA;;QAEI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;;QAEI,wBAAwB;QACxB,gBAAgB;QAChB,OAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,0BAA0B;IAC1B;QACI,kCAAkC;QAClC,aAAa;QACb,sBAAsB;QACtB,uBAAuB;IAC3B;IACA;QACI,cAAc;QACd,WAAW;QACX,mBAAmB;QACnB,iBAAiB;QACjB,oBAAoB;IACxB;IACA,6BAA6B;AACjC;AACA,aAAa;;AAEb;IACI,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;EAEE;AACF;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,0CAA0C;IAC1C,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ","sourcesContent":["[ng\\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {\n    display: none !important;\n}\n\nbody {\n    overflow-y: scroll !important;\n}\n\nbody.modal-open {\n    overflow: hidden !important;\n}\n\n.modal-auto {\n    width: auto;\n}\n\n.modal-md {\n    width: 75%;\n}\n\n.modal-lg {\n    width: 42%;\n}\n@media (max-width: 2000px) {\n    .modal-lg {\n        width: 60%;\n    }\n}\n\n@media (max-width: 1200px) {\n    .modal-lg {\n        width: 83%;\n    }\n}\n\n.nav .fa-stack {\n    margin-top: -0.5em;\n    margin-bottom: -0.5em;\n}\n\n.text-bold {\n    font-weight: bold;\n}\n\n.text-italic {\n    font-style: italic;\n}\n\n.hide, .hidden, .false {\n    display: none;\n}\n\n.float-left {\n    float: left;\n}\n.float-right {\n    float: right;\n}\n.float-right--inline .suspicious-wrapper {\n    display: inline-block;\n    vertical-align: top;\n    height: 27px;\n}\n.float-right--inline .visit-icon-image {\n    width: 30px;\n    height: 27px;\n    padding: 5px 6px 6px 5px;\n}\n.float-right--inline .suspicious-wrapper .visit-icon--transparent {\n    display: flex;\n    padding: 0;\n}\n.float-right--inline .suspicious-wrapper .visit-icon-image::before {\n    position: relative;\n    top: 0;\n    left: 0;\n    width: 19px;\n    transform: none;\n}\n\n.float-right--inline .suspicious-wrapper .visit-icon-image--changed-group::before {\n    width: 18px;\n    top: -1px;\n    left: 1px;\n}\n\n.float-right--inline .suspicious-wrapper .visit-icon-image--car-returned::before\n.float-right--inline .suspicious-wrapper .visit-icon-image--visit-not-change-long::before {\n    top: -1px;\n}\n.float-right--inline .suspicious-wrapper .visit-icon-image--changed-car-category::before {\n    top: -1px;\n    left: 1px;\n}\n.float-right--inline .visit-icon-image--exclamation::before {\n    width: 21px;\n    height: 16px;\n}\n\n.float-right--inline .suspicious-wrapper .visit-icon {\n    width: 30px;\n    font-size: 16.5px;\n    text-align: center;\n}\n\n.float-right--inline .suspicious-wrapper .visit-icon-image--time::before {\n    width: 16px;\n    left: 2px;\n    top: 1px;\n}\n\n.float-right--inline .suspicious-wrapper .visit-icon-image--arrow::before {\n    width: 14px;\n    left: 3px;\n}\n\n.no-margin {\n    margin: 0 !important;\n}\n.no-margin-bottom, .no-margin-bottom>.nav-tabs {\n    margin-bottom: 0 !important;\n}\n.no-padding-top {\n    padding-top: 0;\n}\n.no-padding {\n    padding: 0 !important;\n}\n\n.container {\n    width: 100%;\n    z-index: 1;\n}\n.container.loading, .loading {\n    -webkit-filter: blur(15px);\n    -moz-filter   : blur(15px);\n    -ms-filter    : blur(15px);\n    -o-filter     : blur(15px);\n    filter        : blur(15px);\n}\n\n.underline {\n    text-decoration: underline;\n}\n\n.empty {\n    padding: 30px 0;\n    text-align: center;\n    font-size: 110%;\n    color: #999;\n}\n.empty.empty-big {\n    padding: 80px 0;\n    font-size: 1.15em;\n    color: #afafaf;\n}\n\nh1, .h1, h2, .h2, h3, .h3 {\n    padding: 20px 0;\n    margin: 0;\n}\nh2.bigheader {\n    margin: 0;\n    padding: 18px 20px;\n    text-align: left;\n    font-size: 16px;\n    font-weight: 500;\n    color: inherit;\n    border-bottom: 1px solid var(--l12-delimiter-color, transparent);\n}\nh2, .h2 {\n    font-size: 24px;\n}\nh1, .h1, .h3 {\n    font-weight: 500;\n}\nh1, .h1 {\n    padding-bottom: 26px;\n    font-size: 26px;\n}\n\n.small-padding {\n    padding-bottom: 20px;\n}\n\n.block {\n    margin-bottom: 24px;\n}\n\n.block-mini {\n    margin-bottom: 20px !important;\n}\n.overflow {\n    overflow: hidden;\n}\n.transparent {\n    background: transparent !important;\n}\n.z-up {\n    position: relative;\n    z-index: 10;\n}\n.z-3 { z-index: 3; }\n\n.chartDays .google-visualization-tooltip {\n    margin-top: 40px;\n}\n.chartManagers {\n    /*margin-top: -17px;*/\n}\n.chartManagers .google-visualization-tooltip {\n    margin-top: 55px;\n}\n\n.submenu-prerender {\n    min-height: 48px;\n    margin: 20px 0 15px;\n}\n.submenu-prerender.outer {\n    margin-bottom: 0;\n}\n.submenu-prerender.inner {\n    margin: 0;\n}\n.submenu-prerender .h3 {\n    margin: 0;\n}\n\n.padding-0 {\n    padding: 0 !important;\n}\n\n.graph-prerender {\n    position: relative;\n    background: url(\"../images/graphs.png\") -14px 16px no-repeat;\n    height: 540px;\n    margin-top: -45px;\n}\n.graph-prerender.mini {\n    height: 300px;\n}\n.graph-prerender .inner {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n}\n\ntable.graph-tooltip td { border: 1px lightgray solid; width: 33.3% }\ntable.graph-tooltip {  border: 2px white solid;; width: 100%; text-align: center; margin: 5px 0 }\n\n.calendar-pager {\n    height: 75px;\n    margin-bottom: 20px;\n    margin-top: 40px;\n}\n.calendar-pager.pure {\n    height: auto;\n    margin-bottom: 0;\n}\n.calendar-pager .btn-month {\n    width: 150px;\n    cursor: default;\n    background: #fff !important;\n    color: #000 !important;\n    box-shadow: none !important;\n    text-transform: uppercase !important;\n}\n.calendar-pager .btn-default {\n    border-color: #f0f0f0;\n}\n.month-days {\n    width: 250px;\n}\n.month-days > div:first-child {\n    float: right;\n    margin-right: 4px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.month-days .btn-group {\n    margin-top: -1px;\n}\n.month-days span {\n    text-align: center;\n    width: 36px !important;\n    padding: 6px 0 !important;\n}\n\n.camera-buttons .btn {\n    margin: 0 10px 5px 0;\n}\n.camera-buttons {\n    margin-bottom: 14px;\n}\n\n.c12cs-unsupported-fullscreen #notice-static,\n.c12cs-unsupported-fullscreen .navbar,\n.c12cs-unsupported-fullscreen .navbg {\n    display: none !important;\n}\n\n.well {\n    background: #fff;\n    border: 0;\n    box-shadow: none;\n}\n\n.navbar-inverse .navbar-nav>li>a {\n    color: #efefef;\n}\n\n.panel-heading table, .panel-heading .table {\n    background: transparent;\n    margin: 0 -6px;\n}\n\n.btn-group .btn-default:active,\n.btn-group .btn-default.active,\n.visit-table tr.active,\n.table > tbody > tr.active > td\n{\n    color: #000;\n    background-color: rgba(var(--l12-gray-alt-color-rgb, 160, 160, 160), 0.1) !important;\n    cursor: default;\n    box-shadow: none;\n}\n\n.navbar-default .navbar-nav>li>a:hover, .navbar-default .navbar-nav>li>a:focus {\n    background-color: #fcfcfc;\n}\n\n.navbar small {\n    text-transform: none;\n    font-size: 75%;\n    display: block;\n    height: 35px;\n    margin-top: -5px;\n}\n\n/*график выделять не надо*/\n.table-hover>tbody>tr[name=\"c-st-graph-row\"]:hover {\n    background-color: white;\n}\n#c-st-graph {\n    position: relative;\n    padding: 14px 0 0 0;\n}\n#c-st-graph>span.close{\n    position: absolute; right: 10px; top: 24px; z-index: 100\n}\n\ninput.ng-invalid.ng-dirty {\n    border-color: #ff8f8f !important;\n    background: #fff7f7 !important;\n}\n\n.modal {\n    display: flex !important;\n    display: -webkit-flex !important;\n    padding: 24px;\n}\n.modal-dialog {\n    margin: auto !important;\n}\n.modal-content {\n    padding: 20px 24px;\n}\n\n/*костыли к графикам*/\n.s svg>g>g g rect, .s svg>g>g g>g rect, .s svg>g>g g>g:last-child rect, .s svg>g>g g>g:first-child rect {\n    cursor: pointer !important;\n}\n.s svg>g>g g:last-child rect, .s svg>g>g g:first-child rect {\n    cursor: default !important;\n}\n.s svg>g>g>g>g>rect:last-child[fill-opacity=\"0\"] {\n    /*outline: 4px solid rgba(255, 0, 0, .5);*/\n}\n\n.s svg>g>g {\n    cursor: pointer !important;\n}\n\n.google-visualization-tooltip {\n    padding: 5px 15px !important;\n}\n.google-visualization-tooltip .tt1 {\n    width: 200px;\n}\n.google-visualization-tooltip .tt2 {\n    width: 150px;\n}\n.google-visualization-tooltip b {\n    font-weight: normal;\n    font-size: 115%;\n}\n\n.paging-wrap{\n    text-align: center;\n    clear: both;\n}\n\n.pagination .disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.visit-wrap {\n    position: relative;\n}\n.visit-table tr {\n    cursor: pointer;\n}\n.visit-table tr, .visit-table td {\n    border: 0 !important;\n}\n.visit-col-left {\n    width: 100%;\n    padding-right: 660px;\n}\n.visit-col {\n    width: 640px;\n    position: absolute;\n    top: 0;\n    right: -10px;\n    padding-bottom: 30px;\n}\n\n.visit-photo {\n    text-align: center;\n    margin: 0 0 25px;\n    position: relative;\n    border-radius: var(--l12-radius, 0);\n    background: rgba(var(--l12-gray-alt-color-rgb, 0,0,0), 0.1) url(\"@/assets/img/no-image-car.svg\") center center no-repeat;\n    overflow: hidden;\n    min-height: 340px;\n}\n.visit-photo img {\n    display: block;\n    max-width: 100%;\n}\n.visit-photo .camera-holder {\n    position: absolute;\n    padding: 30px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n.camera-holder .empty {\n    color: #b8bac0;\n    background: transparent;\n    backdrop-filter: blur(18px);\n    font-style: normal;\n    padding: 16px;\n    border-radius: 18px;\n}\n.camera-holder .hider {\n    display: none;\n}\n\ntable.table-transparent, table.table-transparent td, table.table-transparent th {\n    background: transparent;\n    border-color: transparent !important;\n}\n\n.visit-table .visit-icon {\n    display: inline-block;\n    background: transparent;\n    color: var(--l12-dark-color, #000);\n\n    font-size: 1.2em;\n    font-weight: 500;\n\n    border-radius: 6px;\n    padding: 2px 6px 2px;\n\n    margin-left: 3px;\n}\n\n.visit-table .active .visit-icon {\n    background: rgba(255, 255, 255, 0.6);\n    color: var(--l12-dark-color, #000);\n}\n\n.visit-icon-image::before {\n    content: '';\n    display: block;\n    width: 20px;\n    height: 20px;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n.visit-icon-image--changed-group::before {\n    width: 18px;\n    background-image: url('../images/icons/changed_group.svg');\n}\n\n.visit-icon-image--manual-number-input::before {\n    height: 16px;\n    background-image: url('../images/icons/manual_number_input.svg');\n}\n\n.visit-icon-image--payment-canceled::before {\n    background-image: url('../images/icons/payment_canceled.svg');\n}\n\n.visit-icon-image--exclamation::before {\n\n    background-image: url('../images/icons/exclamation.svg');\n}\n\n.visit-icon-image--visit-not-change-long::before {\n    background-image: url('../images/icons/visit_registration.svg');\n}\n\n.visit-icon-image--car-returned::before {\n    background-image: url('../images/icons/car_returned.svg');\n}\n\n.visit-icon-image--changed-car-category::before {\n    background-image: url('../images/icons/changed_car_price_categories.svg');\n}\n\n.visit-icon-image--time::before {\n    width: 18px;\n    background-image: url('../images/icons/clock.svg');\n}\n\n.visit-icon-image--arrow::before {\n    width: 14px;\n    top: 55%;\n    background-image: url('../images/icons/arrow_down.svg');\n}\n\n.red-text {\n    color: var(--l12-danger, #f00);\n}\n.pink-text {\n    color: #9E3C3D;\n}\n\n.visit-icon-set .visit-icon {\n    padding: 0 2px;\n}\n\n.navbar {\n    z-index: 10;\n    position: relative;\n}\n.navbar-nav>li>a {\n    padding-top: 14px;\n    padding-bottom: 14px;\n    border-radius: var(--l12-radius, 0);\n}\n\n.logo {\n    padding: 0 !important;\n    margin-left: 15px;\n}\n.logo img {\n    width: 46px;\n    height: 46px;\n}\n\n.rcBody .navbg {\n    border-top-color: #00c853;\n}\n\n.caps, .wrap .navbar a {\n    text-transform: uppercase;\n}\n\n.relative {\n    position: relative\n}\n\n.btn {\n    font-weight: 500;\n}\n.btn.btn-xs {\n    font-weight: 500;\n    min-width: 26px;\n}\n.btn.btn-lg {\n    font-weight: 400;\n}\n\n.btn-group .btn {\n    text-transform: none;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n/*#region Camera */\n.camera-toolbar {\n    max-width: 1060px;\n    padding: 16px 6px;\n}\n\n.camera-wrap {\n    position: relative;\n    z-index: 0;\n    width: 100%;\n    max-width: 1060px;\n    overflow: hidden;\n    background: #222;\n    aspect-ratio: 16 / 9;\n    border-radius: var(--l12-radius, 0);\n}\n\n.camera-wrap > * {\n    position: absolute !important;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n#camplayer {\n    z-index: 1;\n}\n\n#camera-loading {\n    z-index: 2;\n    display: none;\n}\n#camera-loading.load {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n#camera-loading .preloader {\n    background: url('../images/90-ring-with-bg.svg') center center no-repeat;\n    background-size: contain;\n    height: 60px;\n    width: 60px;\n}\n\n/* #camera-loading .inner, */\n#camera-loading .bar,\n#camera-loading .txt {\n    /* NOTE: В новой версии дизайна и плеера их нет */\n    display: none;\n}\n/*#endregion */\n\n.videoLoader {\n    background: url(\"../images/loadbar.gif\") center 100% no-repeat !important\n}\n.visit-photo .camera-holder .hider {\n    width: 573px;\n}\n\n.payment-box {\n    text-align: center;\n    line-height: 150%;\n    padding: 30px;\n    margin-top: 20px;\n    border: 1px solid black;\n}\n\n.wrap {\n    min-height: 80vh;\n    padding-bottom: 40px;\n    background: var(--l12-bg-color, #fff);\n}\n\ntextarea {\n    max-width: 100%;\n}\n.focused {\n    border-color: #66afe9;\n    outline: 2px solid #66afe9;\n}\ninput[type=\"password\"].focused, input[type=\"text\"].focused, input[type=\"number\"].focused {\n    background: #fff;\n}\n\n.supportMode .supportWrap {\n    position: relative;\n    overflow: auto;\n    background: #fff;\n    margin: 0 auto;\n}\n.supportMode .supportWrap .wrap {\n    padding-bottom: 3000px;\n}\n.supportMode {\n    background: #ccc;\n}\n.supportMode .navbg {\n    display: none;\n}\n.btn-rc {\n    position: absolute;\n    top: 4px;\n    right: 2px;\n}\n\n\n.navbar-right {\n    margin-right: 0;\n}\n\n\n.pointer, .cursor--pointer {\n    cursor: pointer;\n}\n\n.to-save,\n.to-cancel {\n    display: none;\n}\n.to-save, .to-cancel, .to-remove {\n    position: relative;\n}\n\n.to-remove, .to-add {\n    font-size: 16px !important;\n    line-height: 16px !important;\n}\n\n.to-remove-category {\n    position: absolute;\n    right: -1px;\n    top: calc(50% - 11px);\n    font-size: 14px;\n    line-height: 1em;\n    border: none;\n    background: rgba(var(--l12-dark-color-rgb, 0,0,0), 0.3);\n    color: rgba(255, 255, 255, 0.8);\n    padding: 0;\n    border-radius: 100px;\n    height: 20px;\n    width: 20px;\n    text-align: center;\n    backdrop-filter: blur(6px);\n}\n.to-remove-category:hover {\n    opacity: 1;\n    background: var(--l12-danger, #f00);\n    color: #fff;\n}\n\n.ng-dirty .to-save, .ng-dirty .to-cancel, .new .to-save, .new .to-cancel  {\n    display: inline-block;\n}\ntr.ng-dirty,\ntr.ng-dirty .table,\ntbody.ng-dirty tr,\n.new,\ndiv.new .panel-heading,\ndiv.ng-dirty .panel-heading,\n.block--editable.ng-dirty textarea {\n    background: #F2F5F9 !important;\n}\n.ng-dirty input, .new input, div.new .panel-heading input, div.ng-dirty .panel-heading input {\n    background: #FFFFFF;\n}\n.ng-dirty .onlyDirty {\n    display: inline-block !important;\n}\n\n.to-remove {\n    opacity: .3;\n    margin-left: 16px;\n    padding: 3px 4px 1px 3px;\n}\ntr:hover .to-remove {\n    opacity: 1;\n}\n\n.to-add {\n    opacity: .3;\n}\ntr:hover .to-add {\n    opacity: 1;\n}\n\n.table, table {\n    background: #fff;\n}\n\ninput[disabled] {\n    cursor: not-allowed !important;\n}\n\n.editor-column, .editor-column-child {\n    width: 180px;\n}\n.editor-column-child, .editor-column {\n    text-align: right;\n}\n.table-editable-small {\n    margin-bottom: 0;\n}\n.table-editable-small td, .table-editable-small th {\n    border-top: 0 !important;\n}\n\n.table-editable__actions .btn {\n    font-size: 12px;\n    padding: 2px 5px 2px;\n    min-width: 26px;\n    margin-top: -2px;\n    margin-bottom: -2px;\n}\n\n.one-tab .nav.nav-pills {\n    display: none;\n}\n\n.chart-type {\n    position: absolute;\n    right: 70px;\n}\n\n.activate {\n    margin: 100px 0 0 30%;\n}\n.activate div {\n    margin-bottom: 40px;\n}\n.activate .btn-success {\n    text-transform: none;\n    font-size: 20px;\n    line-height: 45px;\n    padding: 10px 36px;\n}\n.activate h1 {\n    font-size: 37px;\n}\n.activate p {\n    font-size: 17px;\n}\n\n.num {\n    border: 1px solid #444;\n    padding: 0 3px 0 4px;\n    border-radius: 4px;\n    background: #fdfdfd;\n    text-decoration: none !important;\n}\na.num:hover {\n    background: #e2e2ff;\n}\n.num .n4 {\n    border-left: 1px solid #444;\n    padding-left: 3px;\n}\n.num .n3 {\n    padding-right: 4px;\n}\n.num .n2 {\n    padding: 0 1px 0 2px;\n}\n.num .n1, .num .n3 {\n    font-size: 85%;\n}\n.table-prices .max-value {\n    margin-top: 3px;\n}\n.table-prices .first {\n    width: 19%;\n}\n.table-prices.table-small tr th.mini,\n.table-prices.table-small tr td.mini {\n    padding: 8px 6px;\n}\n.table-prices.table-small .first {\n    width: 20%;\n}\n.table-prices .for-icon {\n    width: 3%;\n}\n.table-movable:hover {\n    cursor: move;\n}\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\ninput[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n.tosort .connected tr {\n    cursor: move;\n}\n.table>tbody+tbody {\n    border-top: 0;\n}\ntr.new, tr.ng-dirty {\n    cursor: default !important;\n}\n.emptyCategory {\n    height: 30px;\n}\n.emptyCategory:before {\n    content: \" \";\n}\n\n.empty-visit-text {\n    background-color: rgba(0,0,0,.5);\n    padding: 2px 10px;\n    line-height: 25px;\n}\n\n/* Common */\n\n.c-icon-text {\n    font-weight: bold;\n    font-size: 110%;\n    cursor: default;\n}\n.c-icon-big {\n    font-size: 2em;\n}\n.margin-left-5 { margin-left:5px; }\n.margin-left-10 { margin-left:10px; }\n.margin-left-15 { margin-left:15px; }\n.margin-top-5 { margin-top:5px; }\n.margin-top-10 { margin-top:10px; }\n.margin-top-15 { margin-top:15px; }\n.margin-top-25 { margin-top:25px; }\n.margin-top-70 { margin-top:70px; }\n.margin-right-5 { margin-right:5px; }\n.margin-right-10 { margin-right:10px; }\n.margin-right-15 { margin-right:15px; }\n.margin-bottom-5 { margin-bottom:5px; }\n.margin-bottom-10 { margin-bottom:10px; }\n.margin-bottom-15 { margin-bottom:15px; }\n.margin-bottom-30{\n    margin-bottom: 30px;\n}\n.width30 { width:30% }\n.width50 { width:50% }\n.width70 { width:70% }\n.c-display-table\n{\n    display: table;\n    width: 100%;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n.c-display-table .c-display-cell\n{\n    display: table-cell;\n    vertical-align: middle;\n}\n.hcenter\n{\n    margin-left: auto;\n    margin-right: auto;\n}\n.cell-valign-middle {\n    vertical-align: middle !important;\n}\n\n\n/* Analytics & Incomes */\n\n.c-i-btn-dashed.btn-xs {\n    border-bottom: 1px dashed #ccc;\n}\n\n\n/* Alarms*/\n\ntr.c-alarm-entry {\n    cursor: pointer;\n}\ntr.c-alarm-entry-new {\n    background-color: #fcf8e3;\n}\ntr.c-alarm-entry td{\n    vertical-align:middle !important;\n    text-align: center;\n}\ntr.c-alarm-entry td.alarm-pic{\n    width:1%;\n}\n.c-alarm-entry img, .c-alarm-entry .noimg {\n    width: 50px;\n    height: 50px;\n}\n.c-alarm-entry .noimg {\n    display: inline-block;\n    background: url(\"../images/nophoto.gif\") center center no-repeat;\n    background-size: 100% 100%;;\n}\n\n\n/* Alarm modal dialog*/\n.c-alarm-modal-window .modal-dialog {\n    width: 662px;\n    margin-top: 40px;\n    padding: 0px;\n}\n.c-alarm-modal-window .modal-dialog .modal-content .modal-body{\n    padding: 0px;\n}\n.c-alarm-modal-window .modal-dialog .modal-content .modal-body .row{\n    padding: 0px;\n}\n.c-alarm-modal-window .modal-dialog .modal-content .modal-body .close{\n    position: absolute;\n    right: -18px;\n    top: -12px;\n}\n.c-alarm-modal-window img, .c-alarm-modal-window .noimg {\n    max-width: 640px;\n    max-height: 480px;\n}\n.c-alarm-modal-window .camera-preview {\n    width: 640px;\n    height: 480px;\n}\n.c-alarm-modal-window .no-preview {\n    background-color: #000000;\n}\n.c-alarm-modal-window-table{\n    width: 90%;\n    margin: 0 auto;\n}\n.c-alarm-modal-window-table tr{\n    vertical-align:middle !important;\n}\n\n.download-report-modal-window .modal-dialog {\n    width: 700px;\n}\n\ndiv.number-format-hint{\n    width: 136px;\n    text-align: center\n}\n\ndiv.index-summary {\n    position: relative;\n}\ndiv.index-summary .filterable {\n    cursor: pointer;\n    font-weight: normal;\n    color: #E78774;\n}\ndiv.index-summary .filterable.active-filter {\n    font-weight: bold;\n}\ndiv.index-summary > h6 {\n    margin-bottom: 30px;\n}\ndiv.index-summary table {\n    margin-bottom: 0;\n}\n/*\n.table th>small {\n    font-weight: normal;\n}*/\n\n.rub{\n    display: inline-block;\n    line-height: 5px;\n    border-bottom: 1px solid #000000;\n    width: 0.4em;\n}\n\n.panel-pribluding {\n    width: 240px;\n    padding: 20px 20px 18px;\n    text-align: center;\n}\n\n.panel-pribluding-center {\n    margin: 0 auto 40px;\n}\n\n.rating-wrapper {\n    font-size: 1.5em;\n    color: #f8d33a;\n    white-space: nowrap\n}\n\n.login-error {\n    color: var(--l12-danger, #f00);\n    margin: 10px 0 10px 0;\n}\n\n.generate-error{\n    color: var(--l12-danger, #f00);\n    margin: 10px 0 10px 0;\n}\n\n.generate-success{\n    color: var(--l12-green-color, #008000);\n    margin: 10px 0 10px 0;\n}\n\n.login-block {\n    width: 350px;\n    margin-top: 9%;\n    margin-left: -175px;\n    left: 50%;\n    position: absolute;\n}\n\n.login-logo {\n    text-align: center;\n    margin-bottom: 15px;\n}\n\n.login-logo img {\n    width: 200px;\n    height: auto;\n}\n\n.center-block {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.sk3 path.sk3-line {\n    stroke-width: 0;\n}\n\n.sk3-area:hover, .sk3-target:hover .sk3-area {\n    opacity: .7;\n}\n\n.sk3-target {\n    cursor: pointer;\n}\n\n.chart-legends__item {\n    display: inline-block;\n    margin-right: 12px;\n}\n\n.chart-legends__item:last-child {\n    margin-right: 0;\n}\n\n.chart-legends__label {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    margin-right: 4px;\n}\n\n.chart-legends__caption {\n    display: inline-block;\n    font-size: 12px;\n}\n\n.nav-pills--flex {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n}\n\n.nav-checkbox {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.nav-checkbox > li,\n.nav-pills--flex > li {\n    float: none;\n    flex: auto 0 0;\n    margin: 0 8px 8px 0 !important;\n}\n\n.btn-active {\n    color: #fff;\n    background-color: #9f9f9f !important;\n    box-shadow: none;\n}\n\n.c12-indicator-status {\n\n}\n\n.c12-indicator-status--online {\n    color: var(--l12-green-color, #008000);\n}\n\n.c12-indicator-status--offline {\n    color: var(--l12-danger, #f00);\n}\n\n.icon {\n    fill: currentColor; }\n\n.icon-close {\n    width: 1em;\n    height: 1em; }\n\n.btnForm {\n    height: 62px;\n    padding: 0 50px;\n    background: #0e4a82;\n    border-radius: 30px;\n    font-size: 16px;\n    text-transform: uppercase;\n    font-weight: 700;\n    color: #FFF;\n    -webkit-transition: background .2s;\n    transition: background .2s;\n    border: 2px solid #0e4a82;\n}\n@media only screen and (max-width: 1900px) {\n    .btnForm {\n        height: 52px;\n        font-size: 15px; } }\n@media only screen and (max-width: 1023px) {\n    .btnForm {\n        height: 62px;\n        font-size: 16px; } }\n.btnForm:hover {\n    background: #0f518f; }\n\n.popup {\n    display: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    padding: 50px 20px;\n    background: rgba(37, 37, 38, 0.6);\n    overflow: auto;\n    -webkit-transition: all .2s;\n    transition: all .2s;\n    text-align: center;\n    font-size: 0;\n    z-index: 999; }\n.popup:before {\n    content: \"\";\n    display: inline-block;\n    vertical-align: middle;\n    width: 0;\n    height: 100%; }\n@media only screen and (max-width: 1279px) {\n    .popup .btnForm {\n        font-size: 14px; } }\n@media only screen and (max-width: 799px) {\n    .popup {\n        padding: 50px 10px; } }\n@media only screen and (max-width: 320px) {\n    .popup {\n        padding: 0 5px; } }\n@media only screen and (max-width: 1023px) {\n    .popup .btnForm {\n        height: 52px; } }\n.popup.active {\n    display: block; }\n.popup__center {\n    display: inline-block;\n    position: relative;\n    width: 90%;\n    margin: 5%;\n    max-width: 690px;\n    border-radius: 3px;\n    vertical-align: middle;\n    font-size: 14px;\n    text-align: left; }\n@media only screen and (max-width: 1900px) {\n    /*.popup__center {\n      max-width: 510px; } */\n}\n@media only screen and (max-width: 1279px) {\n    /*.popup__center {\n      max-width: 450px; }*/\n}\n.popup__close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding-top: 12px;\n    padding-right: 9px;\n    font-size: 20px;\n    color: rgba(0, 0, 0, 0.46);\n    -webkit-transition: color .2s;\n    transition: color .2s;\n    z-index: 2; }\n@media only screen and (max-width: 1023px) {\n    .popup__close {\n        padding-top: 8px;\n        padding-right: 9px; } }\n.popup__close:hover {\n    color: rgba(0, 0, 0, 1); }\n.popup__close .icon {\n    font-size: 16px; }\n@media only screen and (max-width: 1023px) {\n    .popup__close .icon {\n        font-size: 12px; } }\n.popup__wrap {\n    position: relative;\n    width: 690px;\n    padding: 0px 0px 0px;\n}\n\n@media only screen and (max-width: 1279px) {\n    .popup__wrap {\n        padding: 0px 55px 60px;\n        width: 100%;\n    }\n}\n@media only screen and (max-width: 419px) {\n    .popup__wrap {\n        padding: 0px 25px 60px; } }\n@media only screen and (max-width: 374px) {\n    .popup__wrap {\n        padding: 0px 15px 30px; } }\n\n.share .popup__center {\n    max-width: 690px;\n    line-height: 0.5;\n}\n\n.share-1 .popup__center{\n    background: url(\"../images/background-share.jpg\") no-repeat white;\n}\n\n.share .popup__center li {\n    line-height:1;\n    color: orange;\n    font-size: 35px;\n}\n\n.share .popup__center li span {\n    color: #333333;\n    font-size: 22px;\n}\n\n.share .popup__center ul {\n    padding-top: 10px;\n}\n\n.share-left {\n    display: inline-block;\n    position: relative;\n    vertical-align: middle;\n    width: 50%;\n    float:left;\n    font-weight: 600;\n\n    padding: 20px;\n}\n\n.share-right {\n    width: 43%;\n    float:left;\n    padding-bottom: 34px;\n    padding-right: 50px;\n}\n\n.share .btnForm {\n    height: 48px;\n    padding: 0px;\n}\n\n.share-1 .form__field {\n    margin-bottom: 15px;\n}\n\n.share__wrap {\n    padding: 20px 20px 82px 30px;\n}\n\n.display {\n    display: none;\n}\n\n.share__title {\n    font-size: 22px;\n    text-align: left;\n    padding-top: 17px;\n}\n\n.thank {\n    display: none;\n    padding-top: 10px;\n    text-align: center;\n    line-height: 1;\n    font-size: 18px;\n}\n@media only screen and (max-width: 1900px) {\n    .thank {\n        padding-top: 10px; } }\n.thank__title {\n    font-size: 22px;\n    padding-bottom: 7px;\n}\n@media only screen and (max-width: 1900px) {\n    .thank__title {\n        font-size: 22px; } }\n@media only screen and (max-width: 1900px) {\n    .thank__content {\n        font-size: 18px; } }\n.form__wrap {\n    max-width: 690px;\n    margin: 0 auto; }\n\n.form__wrap .btnForm {\n    height: 44px;\n}\n\n.form__wrap .form__field input {\n    height: 44px;\n}\n\n.form__field {\n    margin-bottom: 30px;\n    float:left;\n    width: 33%;\n    padding-left:1px;\n    padding-right:5px;\n}\n\n.form__field .error {\n    border-color: var(--l12-danger, #f00);\n}\n\n.form__field_btn {\n    padding-right:0px;\n}\n@media only screen and (max-width: 320px) {\n    .form__field {\n        margin-bottom: 15px; } }\n\n.form__field .form__input, .form__field .btnForm {\n    font-size: 16px;\n}\n\n@media only screen and (max-width: 1900px) {\n    .form__field {\n        float:left;\n        width: 30%;\n    } }\n@media only screen and (max-width: 800px) {\n\n    .form__field {\n        float:none;\n        width: 100%;\n        padding-top: 10px;\n    }\n\n    .form__wrap {\n        max-width: 450px;\n        margin: 0 auto;\n    }\n\n    .form__field .form__input, .form__field .btnForm {\n        font-size: 15px;\n    }\n}\n.form__input {\n    width: 100%;\n    height: 62px;\n    border: 2px solid #e6e6e6;\n    border-radius: 30px;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 700;\n    background-color: white;\n    border-color: #0e4a82;\n}\n.form__input:-moz-placeholder, .form__input::-moz-placeholder {\n    color: #bdbdbd;\n    opacity: 1; }\n.form__input::-webkit-input-placeholder {\n    color: #bdbdbd; }\n@media only screen and (max-width: 1900px) {\n    .form__input {\n        height: 52px;\n        font-size: 15px; } }\n@media only screen and (max-width: 1279px) {\n    .form__input {\n        font-size: 14px; } }\n@media only screen and (max-width: 320px) {\n    .form__input {\n        height: 40px; } }\n\n.form__btn {\n    width: 100%; }\n\n\n@media only screen and (max-width: 1900px) {\n    .share__title {\n        font-size: 20px;\n    }\n\n}\n\n.share__wrap_thank {\n    padding: 20px 20px 20px 30px;\n}\n\n\n.share .checkbox {\n    vertical-align: top;\n    margin: 0 3px 0 0;\n    width: 17px;\n    height: 17px;\n}\n\n.share .checkbox + label {\n    cursor: pointer;\n}\n\n.share .checkbox:not(checked) {\n    position: absolute;\n    opacity: 0;\n}\n.share .checkbox:not(checked) + label {\n    position: relative;\n    padding: 0 0 0 60px;\n    padding-right: 10px;\n}\n\n.share .checkbox:not(checked) + label:before {\n    content: '';\n    position: absolute;\n    top: -4px;\n    left: 0;\n    width: 50px;\n    height: 26px;\n    border-radius: 13px;\n    background: #CDD1DA;\n    box-shadow: inset 0 2px 3px rgba(0,0,0,.2);\n}\n\n.demo__stand_title {\n    position: fixed;\n    left: 0px;\n    background-color: var(--l12-danger, #f00);\n    color: white;\n    font-size: 14px;\n    z-index: 3000;\n    font-weight: 500;\n    padding: 10px 30px 10px 20px;\n    border-bottom-right-radius: 18px;\n    user-select: none;\n}\n\n\n.share .checkbox:not(checked) + label:after {\n    content: '';\n    position: absolute;\n    top: -2px;\n    left: 2px;\n    width: 22px;\n    height: 22px;\n    border-radius: 10px;\n    background: #FFF;\n    box-shadow: 0 2px 5px rgba(0,0,0,.3);\n    transition: all .2s;\n}\n\n\n.share .checkbox:checked + label:before {\n    background: #0e4a82;\n}\n\n.share .checkbox:checked + label:after {\n    left: 26px;\n}\n\n@media only screen and (max-width: 810px) {\n    .share .popup__center {\n        max-width: 333px;\n        line-height: 1;\n    }\n\n    .share-2 .popup__center {\n        max-width: 333px;\n    }\n\n    .share__title {\n        font-size: 18px;\n    }\n\n    .share .popup__center li {\n        line-height: 1;\n        font-size: 35px;\n    }\n\n    .share .popup__center li span {\n        font-size: 18px;\n    }\n\n    .share-1 .share__wrap {\n        padding: 20px 20px 134px 30px;\n    }\n\n    .share-1 .popup__center {\n        max-width: 333px;\n        line-height: 1;\n    }\n\n    .share-1 .popup__center {\n        background: url(\"../images/background-share-phone.png\") no-repeat white;\n    }\n\n    .share-left, .share-right {\n        width: 100%;\n        float: none;\n    }\n}\n\n.modal-content .tab-content {\n    margin-top: 16px;\n}\n\n.dropdown-menu > li:hover {\n    cursor: pointer;\n}\n\n.input-group-btn select {\n    border-color: #ccc;\n    height: 34px;\n}\n\n.input-group-btn select.btn-default:focus {\n    background: #fff;\n}\n\na.filterable {\n    color: #1170ac;\n}\n\na.filterable.active {\n    font-weight: bold;\n}\n\n.table-tree__node {\n    cursor: pointer;\n}\n\n.table-tree__node {\n    transition: all linear 0.25s;\n}\n.table-tree__node.ng-hide {\n    opacity: 0;\n}\n\n.table-tree__node--level1 td:first-child {\n    padding-left: 12px;\n}\n\n.table-tree__node--level2 td:first-child {\n    padding-left: 24px;\n    font-style: italic;\n}\n\n.visible-important {\n    display: block !important;\n}\n\n.label-primary {\n    background-color: #337ab7;\n}\n\n.margin-bottom-0 {\n    margin-bottom: 0!important;\n}\n\n.list-expand {\n    position: relative;\n    width: 15px;\n    height: 10px;\n    padding: 0;\n    margin-right: 5px;\n    background: transparent;\n    border: 0;\n    outline: none;\n}\n\n.list-expand::before {\n    content: '';\n    position: relative;\n    top: 1px;\n    left: 2px;\n    display: block;\n    width: 8px;\n    height: 8px;\n    border-top: 2px solid currentColor;\n    border-left: 2px solid currentColor;\n    transform: rotate(45deg);\n}\n.list-expand.expanded::before {\n    transform: rotate(-135deg);\n    top: -1px;\n}\n\n.suspicious-container {\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n    padding-left: 24px;\n}\n\n.event-description {\n    max-width: 85%;\n}\n\n.event-confirm-container {\n    margin-left: auto;\n}\n\n.suspicious-event__btn {\n    float: left;\n    position: relative;\n    top: -2px;\n    border: 0;\n    background-color: transparent;\n    color: currentColor;\n    font-size: 19px;\n    cursor: pointer;\n    transition: color 200ms;\n    opacity: 0.8;\n}\n\n.suspicious-event__btn:hover,\n.suspicious-event__btn:focus {\n    color: #222;\n    opacity: 1;\n}\n\n.event--confirmed {\n    color: #42a956;\n}\n\n.button-expand::before {\n    content: '';\n    position: absolute;\n    display: block;\n    width: 9px;\n    height: 9px;\n    top: 50%;\n    left: 50%;\n    border-left: 3px solid #000;\n    border-bottom: 3px solid #000;\n    transform-origin: 50% 50%;\n    transform: translate(-50%, -50%) rotate(-45deg);\n}\n\n.button-expand--expanded::before {\n    transform: translate(-50%, -50%) rotate(135deg);\n    top: 15px;\n}\n\n.average-profits-expand {\n    position: relative;\n    margin-right: 5px;\n    padding: 0;\n    border: 0;\n    background-color: transparent;\n    outline: none;\n}\n\n.average-profits-expand::before {\n    content: '';\n    display: block;\n    position: relative;\n    top: -3px;\n    width: 8px;\n    height: 8px;\n    border-left: 2px solid #000;\n    border-bottom: 2px solid #000;\n    border-radius: 2px;\n    transform: rotate(-45deg);\n}\n\n.average-profits-expand--expanded::before {\n    transform: rotate(135deg);\n    top: 0;\n}\n\n.station-name {\n    padding-left: 35px;\n}\n\ntable>tbody>tr>.table-cell--border-white { /* чтобы точечно перебить бутстраповский стиль */\n    border-color: #fff;\n}\n\n.report-label {\n    float: left;\n}\n\n.report-label__text {\n    margin-right: 10px;\n}\n\n.report-label__input {\n    display: inline-block;\n    vertical-align: top;\n}\n\n.report-btn-wrapper {\n    text-align: left;\n}\n\n.report-btn {\n    margin-left: 24.9em;\n}\n\n.ratings-icon {\n    display: block;\n    width: 20px;\n    height: 20px;\n    margin: 0 auto;\n    background-position: 50% 50%;\n    -webkit-background-size: contain;\n    background-size: contain;\n    background-repeat: no-repeat;\n}\n.ratings-icon--total {\n    background-image: url(\"../images/icons/total.svg\");\n}\n.ratings-icon--reviews {\n    background-image: url(\"../images/icons/reviews.svg\");\n}\n.ratings-icon--normative {\n    background-image: url(\"../images/icons/normative.svg\");\n}\n.ratings-icon--check {\n    background-image: url(\"../images/icons/check.svg\");\n}\n.happysmail-icon {\n    background-image: url(\"../images/icons/emotions/happy.svg\");\n}\n\n.nhappysmail-icon {\n    background-image: url(\"../images/icons/emotions/nhappy.svg\");\n}\n\n.neutralsmail-icon {\n    background-image: url(\"../images/icons/emotions/neutral.svg\");\n}\n\n.nsadsmail-icon {\n    background-image: url(\"../images/icons/emotions/nsad.svg\");\n}\n\n.sadsmail-icon {\n    background-image: url(\"../images/icons/emotions/sad.svg\");\n}\n\n.ratings-icon--productivity,\n.ratings-icon--time {\n    background-image: url(\"../images/icons/productivity.svg\");\n}\n\n.ratings-icon--suspicious {\n    background-image: url(\"../images/icons/suspicious.svg\");\n}\n\n.ratings-cell {\n    text-align: center;\n}\n\n.ratings-cell-error {\n    text-align: center;\n    color: var(--l12-danger, #f00);\n}\n\n.discount {\n    position: relative;\n}\n\n.discount__row {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 10px;\n}\n\n.discount__row:last-child {\n    margin-bottom: 0;\n}\n\n.discount__label {\n    text-align: right;\n}\n\n.discount__input {\n    width: 273px;\n}\n\n.discount__input,\n.discount__label {\n    margin-right: 10px;\n}\n\n.discount__small {\n    display: block;\n}\n\n.discount__btn {\n    margin-left: auto;\n    margin-right: 300px;\n}\n\n.discount__upload-result {\n    text-align: center;\n}\n\n.discount__link {\n    text-decoration: underline;\n}\n\n.client-app {\n    margin-left: 10px;\n    padding-top: 6px;\n}\n\n.client-app__label-text {\n    vertical-align: text-bottom;\n    color: rgba(51, 51, 51, .65);\n    font-weight: 400;\n}\n\n.analytic-controls {\n    width: 100%;\n    margin-bottom: 24px;\n    border-bottom: 1px solid #ddd;\n}\n\n.analytic-controls .btn {\n    margin-bottom: 24px;\n}\n\n.table--analytic>tbody:nth-child(odd)>tr.table__parent-row {\n    background: #f7f7f7;\n}\n\n.table--analytic>tbody:nth-child(even)>tr.table__parent-row {\n    background: #fff;\n}\n\n.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(even) {\n    background: #fcfcfc;\n}\n\n.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(odd) {\n    background: #fff;\n}\n.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(odd):hover,\n.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(odd):focus,\n.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(even):hover,\n.table--analytic>tbody:nth-child(even)>tr.table__child-row:nth-child(even):hover {\n    background: #f7f7f7;\n}\n\n.table--analytic>tbody:nth-child(even)>tr.table__parent-row+tr:hover,\n.table--analytic>tbody:nth-child(even)>tr.table__parent-row+tr:focus {\n    background: #f7f7f7;\n}\n\n.table--analytic>tbody:nth-child(even)>tr.table__parent-row:hover,\n.table--analytic>tbody:nth-child(even)>tr.table__parent-row:focus,\n.table--analytic>tbody:nth-child(odd)>tr.table__parent-row:hover,\n.table--analytic>tbody:nth-child(odd)>tr.table__parent-row:focus {\n    background: #f1f1f1;\n}\n\n.table--analytic th,\n.table--analytic td {\n    width: 14%;\n}\n\n.table--analytic td {\n    max-width: 216px;\n    overflow-wrap: break-word;\n}\n\n.table__body--hide-children .table__child-row {\n    display: none;\n}\n\n.table__parent-row {\n    cursor: pointer;\n}\n\n.table__child-name {\n    display: block;\n    padding-left: 24px;\n    font-style: italic;\n}\n\n.table--analytic .table__row--borderless {\n    background: #f7f7f7;\n}\n\n.table--analytic .table__row--borderless th{\n    border-bottom: none;\n}\n\n.point-filter {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n}\n\nth.orderBy {\n    cursor: pointer;\n}\nth.orderBy:after {\n    font-family: 'Glyphicons Halflings';\n    content: \"\\e150\";\n    position: relative;\n    top: 1px;\n    display: inline-block;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    margin-left: 3px;\n    font-size:10px;\n    opacity:0\n}\n\nth.orderBy:hover::after {\n    opacity: 1\n}\n\n/*#region Mobile adaptive*/\n:root {\n    --app-btn-border-radius: 5px;\n}\n\n.c-mb-2 { margin-bottom: 20px !important; }\n.c-mb-3 { margin-bottom: 30px !important; }\n\n.login-block .form-control::placeholder {\n    color: transparent;\n}\n\n@media screen and (max-width: 767px) {\n    .wrap {\n        padding-bottom: 0;\n        padding-top: var(--l12-head-offset, 80px);\n    }\n\n    .no-adaptive-wrap {\n        min-width: 768px;\n    }\n\n    /*#region Login page */\n    .login-block {\n        margin-top: 14vh;\n        max-width: 300px;\n        max-width: 260px;\n        left: 0;\n        margin: 0 auto;\n        position: relative;\n    }\n    .login-block .btn {\n        width: 100% !important; /* style=\"width: 120px;\" */\n        padding-top: 10px;\n        padding-bottom: 10px;\n    }\n    .login-block .form-control {\n        padding-top: 9px;\n        padding-bottom: 9px;\n        height: 40px;\n    }\n\n    .login-block label {\n        display: none;\n    }\n\n    .login-block .form-control::placeholder {\n        color: #555;\n    }\n\n    .login-block form > * {\n        margin-top: 0 !important;\n        margin-bottom: 16px;\n    }\n\n    .login-logo {\n        padding-top: calc(10vh - 100px);\n        padding-bottom: calc(15vh - 100px);\n    }\n\n    .login-logo img {\n        max-width: 150px;\n    }\n    /*#endregion Login page */\n\n    .calendar-pager {\n        margin-bottom: 0;\n        margin-top: 50px;\n        display: inline-block;\n        height: auto;\n    }\n\n    #chart-month {\n        margin-top: -42px !important;\n    }\n    #chart-month > .btn {\n        margin-right: 0 !important;\n    }\n\n    #chart-detailed .sk3,\n    #chart-month .sk3 {\n        overflow-x: auto;\n        width: 100%;\n    }\n\n    .bigheader .pull-right {\n        float: none !important;\n        display: flex;\n        flex-wrap: wrap;\n        padding-top: 10px;\n    }\n    .bigheader .pull-right > * {\n        margin-bottom: 4px;\n        margin-left: 0 !important;\n        margin-right: 4px;\n    }\n\n    /* ---- */\n\n    .table-striped tr {\n        background: #fff;\n    }\n\n    .index-summary .table tr th,\n    .index-summary .table tr td {\n        min-width: 140px;\n        padding-top: 8px;\n        padding-bottom: 8px;\n    }\n\n    .index-summary .table tr th:first-child,\n    .index-summary .table tr td:first-child {\n        position: -webkit-sticky;\n        position: sticky;\n        left: 0;\n        background: #fff;\n    }\n\n    .index-summary .table tr.active > td:first-child {\n        background-color: #f5f5f5;\n    }\n\n    /*#region Обратная связь */\n    .issue-popup {\n        min-height: calc(100vh - 21px * 2);\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n    }\n    .issue-popup .btn {\n        display: block;\n        width: 100%;\n        margin-bottom: 20px;\n        padding-top: 14px;\n        padding-bottom: 14px;\n    }\n    /*#endregion Обратная связь */\n}\n/*#endregion*/\n\n.filters__item {\n    display: inline-block;\n    padding-right: 10px;\n    vertical-align: top;\n}\n.filters__item.top {\n    vertical-align: top;\n}\n\n.filters__item .form-control {\n    display: inline-block;\n}\n\n/**\n    fixed окно в клиента / рассылках с количеством выбранных\n */\n.c12-toggle-all-window {\n    position: fixed;\n    bottom: 0;\n    left: 50%;\n    background: #fff;\n    padding: 20px;\n    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);\n    width: 440px;\n    margin: 0 0 30px -220px;\n    z-index: 10;\n    border-radius: var(--l12-radius, 0);\n}\n.c12-toggle-all-inner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.c12-toggle-all-inner button {\n    outline: none;\n}\n.c12-toggle-all-btns {\n    text-align: center;\n}\n.c12-toggle-all-btns .btn {\n    margin: 2px 0;\n}\n@media screen and (max-width: 600px) {\n    .c12-toggle-all-window {\n        width: 300px;\n        margin-left: -150px;\n    }\n    .c12-toggle-all-inner {\n        flex-direction: column;\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
